import api, { ApiResponse } from '../core/api';

export interface Settlement {
  _id: string;
  module: string;
  resourceType: string;
  resourceNumber: string;
  partnerType: string;
  partnerId: { firstName?: string; lastName?: string; email?: string };
  grossAmount: number;
  commissionAmount: number;
  payoutAmount: number;
  status: 'pending' | 'processing' | 'paid' | 'failed' | 'on_hold' | 'settled';
  failureReason?: string;
  promoCode?: string;
  settledAt?: string;
  createdAt: string;
}

export interface SettlementSummaryItem {
  _id: string;
  count: number;
  totalPayout: number;
  totalCommission: number;
  settled?: number;
  pending?: number;
  failed?: number;
}

export interface SettlementSummaryResponse {
  byStatus: SettlementSummaryItem[];
  byModule: SettlementSummaryItem[];
}

export async function getSettlements(params?: {
  status?: string;
  module?: string;
  page?: number;
  limit?: number;
}) {
  const res = await api.get<ApiResponse<Settlement[]>>('/settlements', { params });
  return res.data;
}

export async function getSettlementSummary() {
  const res = await api.get<ApiResponse<SettlementSummaryResponse | SettlementSummaryItem[]>>('/settlements/summary');
  const data = res.data.data;
  if (Array.isArray(data)) {
    return { byStatus: data, byModule: [] } as SettlementSummaryResponse;
  }
  return data as SettlementSummaryResponse;
}

export async function retrySettlement(id: string) {
  const res = await api.post(`/settlements/${id}/retry`);
  return res.data;
}
